const Main = ({ children }) => <main>{children}</main>;

export default Main;
